import { Injectable, signal } from '@angular/core';

/**
 * App-wide shell layout state (sidebar collapse, notifications drawer), shared so code
 * outside `ShellComponent` — e.g. the guided-tour hooks — can put the layout into a
 * known state and restore it afterwards.
 */
@Injectable({ providedIn: 'root' })
export class LayoutStateService {
  readonly sidebarCollapsed = signal(false);
  readonly notificationsOpen = signal(false);
}
